import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {NotificationService} from './notification.service';

@Injectable()
export class ErrorsHandler implements ErrorHandler {

    constructor(private injector: Injector) {
    }

    // tslint:disable-next-line:typedef
    handleError(error: Error | HttpErrorResponse) {

        const notificationService = this.injector.get(NotificationService);
        const router = this.injector.get(Router);
        if (error instanceof HttpErrorResponse) {
            // Server or connection error happened
            const theError: HttpErrorResponse = error;

            if (!navigator.onLine) {
                // Handle offline error
                return notificationService.notify('Sin conexión a Internet');
            } else {
                // Handle Http Error (error.status === 403, 404...)
                // return notificationService.notify(`${error.status} - ${error.message}`);
                let theMessage = 'Hubo un error al realizar esta acción.';
                if (theError.error && typeof theError.error === 'string' && theError.error.includes('##')) {
                    const message: string[] = theError.error.split('##');
                    let lastPart = message[message.length - 1];
                    if (lastPart.includes(':')) {
                        const parts = lastPart.split(':');
                        lastPart = parts[parts.length - 1].trim();
                    }
                    theMessage = lastPart;
                }
                if (theMessage.length > 300) {
                    theMessage = theMessage.substring(0, 300);
                }
                return notificationService.notify('Error: ' + theMessage);
            }
        } else {
            // Handle Client Error (Angular Error, ReferenceError...)
            // router.navigate(['/error'], {queryParams: {error: error}});
        }
        // Log the error anyway
        console.error( error );
    }
}
